import { render, staticRenderFns } from "./BooksMenu.vue?vue&type=template&id=7aa9e8ea&"
import script from "./BooksMenu.vue?vue&type=script&lang=js&"
export * from "./BooksMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports